@if (useFastIconType) {
    <vn-menu-item
        class="bottom-sheet-item"
        [item]="item"
        [section]="MenuSection.BottomSheet"
        (onClick)="close()"
        [displayMode]="MenuDisplayMode.FastIcon"
        badgePosition="FastIcon"
        linkClass="list-nav-link"
        iconClass="ui-icon ui-icon-size-xl"
        badgeClass="badge-offset"
        textClass="list-nav-txt" />
} @else {
    <vn-menu-item
        class="bottom-sheet-item"
        [item]="item"
        [section]="MenuSection.BottomSheet"
        (onClick)="close()"
        [displayMode]="MenuDisplayMode.Icon"
        badgePosition="icon"
        linkClass="list-nav-link"
        iconClass="ui-icon ui-icon-size-xl"
        badgeClass="badge-offset"
        textClass="list-nav-txt" />
}
